import {PDFDocumentProxy} from 'pdfjs-dist';

export type PdfHighlight = {
  pageIndex: number;
  content: string;
};

export const getPdfHighlights = async (
  document: PDFDocumentProxy
): Promise<PdfHighlight[]> => {
  const pageNumbers = Array.from(
    {length: document.numPages},
    (_, index) => index + 1
  );

  const annotationsWithPage = await Promise.all(
    pageNumbers.map(async (pageNumber) => {
      const page = await document.getPage(pageNumber);
      const annotations = await page.getAnnotations();
      return annotations
        .filter((annotation) => annotation.subtype === 'Highlight')
        .map((annotation) => ({
          pageIndex: page.pageNumber - 1,
          content: annotation.contentsObj.str,
        }));
    })
  );

  return annotationsWithPage
    .flatMap((highlights) => highlights)
    .filter((highlight, index, highlights) => {
      const indexOfHighlight = highlights.findIndex(
        (h) =>
          h.pageIndex === highlight.pageIndex && h.content === highlight.content
      );
      return indexOfHighlight === index;
    });
};
